// frontend/src/PaymentOptions.js
// frontend/src/PaymentOptions.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import mpesaLogo from './assets/mpesa.png';
import flutterwaveLogo from './assets/flutterwave.png';
import paypalLogo from './assets/paypal.png';
import './PaymentOptions.css';

const PaymentOptions = () => {
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);

  // Load pending payment data from localStorage
  useEffect(() => {
    const storedPayment = localStorage.getItem('pendingPayment');
    if (storedPayment) {
      setPaymentData(JSON.parse(storedPayment));
    } else {
      alert('No pending payment found!');
      navigate('/dashboard');
    }
  }, [navigate]);

  // Handle payment option selection
  const handlePaymentSelection = (method) => {
    if (!paymentData) return;

    switch (method) {
      case 'mpesa':
        navigate(
          `/payment?amount=${paymentData.amount}&description=${encodeURIComponent(
            paymentData.description
          )}`
        );
        break;
      case 'flutterwave':
        navigate('/flutterwave-payment');
        break;
      case 'paypal':
        navigate('/paypal-payment');
        break;
      default:
        console.warn('Unknown payment method selected:', method);
        break;
    }
  };

  // Show loader if paymentData is not yet loaded
  if (!paymentData) {
    return (
      <div className="payment-options-container">
        <h2>Loading payment information...</h2>
      </div>
    );
  }

  return (
    <div className="payment-options-container">
      <h1>Choose Your Payment Method</h1>
      <div className="payment-summary">
        <p>
          <strong>Amount:</strong> KES {paymentData.amount}
        </p>
        <p>
          <strong>Description:</strong> {paymentData.description}
        </p>
      </div>

      <div className="options-grid">
        {/* MPESA */}
        <div
          className="option-card"
          onClick={() => handlePaymentSelection('mpesa')}
        >
          <img src={mpesaLogo} alt="MPESA" />
          <h3>MPESA</h3>
          <p>Pay via Safaricom MPESA STK Push</p>
        </div>

        {/* Flutterwave */}
        <div
          className="option-card"
          onClick={() => handlePaymentSelection('flutterwave')}
        >
          <img src={flutterwaveLogo} alt="Flutterwave" />
          <h3>Flutterwave</h3>
          <p>Pay via Card, Mobile Money, or Bank Transfer</p>
        </div>

        {/* PayPal */}
        <div
          className="option-card"
          onClick={() => handlePaymentSelection('paypal')}
        >
          <img src={paypalLogo} alt="PayPal" />
          <h3>PayPal</h3>
          <p>Pay securely via PayPal</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentOptions;
